import { createContext, useContext } from 'react';
/** @type {import('react').Context<import('./types').ControlGroupContext>} */

export var ControlGroupContext = /*#__PURE__*/createContext({});
export var useControlGroupContext = function () {
  return useContext(ControlGroupContext);
};